import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = API_URLS.MAINTENANCES;

async function fetchItemsMaintenace() {
    try {
        let response = await api.get(`${basePath}/items`);

        let treated = errorHandling.handleResponse(
            response,
            "maintenancesService.fetchItemsMaintenace"
        );
        if (treated) {
            // Normaliza: sempre retorna array
            return Array.isArray(treated) ? treated : [treated];
        }
        return null;
    } catch (error) {
        errorHandling.cathError(error, "maintenancesService.fetchItemsMaintenace");
        return null;
    }
}

async function createNewItem(item) {
    const payload = {
        maintenanceItemId: item.maintenanceItemId,
        maintenanceItemName: item.maintenanceItemName,
        active: item.active
    }
    try {
        let response = await api.post(`${basePath}/items`, JSON.stringify(payload));

        // let treated = errorHandling.handleResponse(
        //     response,
        //     "maintenancesService.createNewItem"
        // );
        if (response.status === 201) {
            // Normaliza: sempre retorna array
            return response.status === 201 ? true : false;
        }
        return null;
    } catch (error) {
        errorHandling.cathError(error, "maintenancesService.createNewItem");
        throw error;
    }
}

async function createNewScheduling(scheduling) {
    const payload = {
        MaintenanceScheduleId: scheduling.maintenanceScheduleId ?? 0,
        VehicleId: scheduling.vehicleId,
        MaintenanceItemId: scheduling.maintenanceItemId,
        MaintenanceBase: scheduling.maintenanceBase === "" ? "DI" : scheduling.maintenanceBase,
        Mileage: scheduling.mileage ?? 0,
        Days: scheduling.days ?? 0,
        Hours: scheduling.hours ?? 0,
        Active: scheduling.active ?? "S",
        Cost: scheduling.cost ?? 0,
        MaintenanceStatus: scheduling.maintenanceStatus ?? 1,
        StartDate: scheduling.startDate ?? null,
        ExecutionDate: scheduling.executionDate ?? null
    };
    
    try {
        let response = await api.post(`${basePath}/schedules`, JSON.stringify(payload));

        if (response.status === 201) {
            return true;
        }
        return false;
    } catch (error) {
        errorHandling.cathError(error, "maintenancesService.createNewScheduling");
        return false;
    }
}

async function fetchItemsScheduling(vehicleId, isOpen) {
    try {
        const isOpenParam = isOpen ? 'S' : 'N';
        let response = await api.get(`${basePath}/schedules?vehicleId=${vehicleId}&isOpen=${isOpenParam}`);

        let treated = errorHandling.handleResponse(
            response,
            "maintenancesService.fetchItemsScheduling"
        );
        if (treated) {
            // Normaliza: sempre retorna array
            return Array.isArray(treated) ? treated : [treated];
        }
        return null;
    } catch (error) {
        errorHandling.cathError(error, "maintenancesService.fetchItemsScheduling");
        return null;
    }
}


export const maintenancesService = {
    fetchItemsMaintenace,
    createNewItem,
    createNewScheduling,
    fetchItemsScheduling
};
